module.exports = __webpack_public_path__ + "img/domicilio.401f4c11.svg";